export default __webpack_public_path__ + "static/media/work-profile@3x.a2f8ce00.svg";